<style>
@import '../../custom/css/ver-cotacoes-usuarios.css';
</style>

<template>
  <div id="relatorioRepresentante" class="cotacoes">
    <div class="row m-0">
      <div class="col-lg-3 col-md-3 col-sm-12 p-0">
        <v-select
          label="nome"
          v-model="filtro.cidade"
          :options="cidades"
          placeholder="Cidade"
        >
          <div slot="no-options">Essa cidade não está cadastrada.</div>
        </v-select>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-12 p-0">
        <input
          type="date"
          class="form-control"
          v-model="filtro.dataInicial"
          placeholder="Data Inicial"
        />
      </div>
      <div class="col-lg-3 col-md-3 col-sm-12 p-0">
        <input
          type="date"
          class="form-control"
          v-model="filtro.dataFinal"
          placeholder="Data Final"
        />
      </div>
      <div class="col-lg-3 col-md-3 col-sm-12 p-0">
        <div class="btn btn-success" @click="buscar()">Buscar</div>
      </div>
    </div>
    <h3 class="title text-uppercase font-weight-bold m-t-50">
      Cotações Enviadas
    </h3>
    <hr class="linha-amarela" />
    <table class="table">
      <thead class="letter-orange">
        <tr>
          <th>Listagem</th>
          <th>Código</th>
          <th>Representante</th>
          <th>Lojista</th>
          <th>Preferência</th>
          <th>Criado em.</th>
          <th>Frete</th>
          <th>Valor Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(cotacao, index) in cotacoesSingleEnviadas">
          <th>{{ index + 1 }}</th>
          <th>{{ cotacao.cot_cotacao_id }}</th>
          <th v-if="cotacao.cot_usuario_enviador_dados.dadosLojista !== null">
            {{
              cotacao.cot_usuario_enviador_dados.dadosLojista.nome_responsavel
            }}
          </th>
          <th v-else>
            {{
              cotacao.cot_usuario_recebedor_dados.dadosLojista.nome_responsavel
            }}
          </th>
          <th v-if="cotacao.cot_usuario_enviador_dados.dadosCliente !== null">
            {{ cotacao.cot_usuario_enviador_dados.dadosCliente.nome }}
          </th>
          <th
            v-else-if="
              cotacao.cot_usuario_recebedor_dados.dadosCliente !== null
            "
          >
            {{ cotacao.cot_usuario_recebedor_dados.dadosCliente.nome }}
          </th>
          <th
            v-if="cotacao.cot_usuario_enviador_dados.dadosProfissional !== null"
          >
            {{ cotacao.cot_usuario_enviador_dados.dadosProfissional.nome }}
          </th>
          <th
            v-else-if="
              cotacao.cot_usuario_recebedor_dados.dadosProfissional !== null
            "
          >
            {{ cotacao.cot_usuario_recebedor_dados.dadosProfissional.nome }}
          </th>
          <th>{{ cotacao.cot_preferencia }}</th>
          <th>{{ cotacao.criado_em }}</th>
          <th>{{ cotacao.cot_frete }}</th>
          <th>{{ cotacao.cot_valor_total }}</th>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="11">
            Valor total de Frete:
            <input
              type="text"
              class="form-control input-valores-totais"
              v-money="money"
              :value="cSEValorFrete"
              readonly
            />
          </th>
        </tr>
        <tr>
          <th colspan="11">
            Valor total de venda(já considera o frete):
            <input
              type="text"
              class="form-control input-valores-totais"
              v-money="money"
              :value="cSEValorTotal"
              readonly
            />
          </th>
        </tr>
      </tfoot>
    </table>

    <h3 class="title text-uppercase font-weight-bold m-t-50">
      Cotações Ganhas
    </h3>
    <hr class="linha-amarela" />
    <table class="table">
      <thead class="letter-orange">
        <tr>
          <th>Listagem</th>
          <th>Código</th>
          <th>Representante</th>
          <th>Lojista</th>
          <th>Preferência</th>
          <th>Criado em.</th>
          <th>Frete</th>
          <th>Valor Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(cotacao, index) in cotacoesSingleGanhas">
          <th>{{ index + 1 }}</th>
          <th>{{ cotacao.cot_cotacao_id }}</th>
          <th v-if="cotacao.cot_usuario_enviador_dados.dadosLojista !== null">
            {{
              cotacao.cot_usuario_enviador_dados.dadosLojista.nome_responsavel
            }}
          </th>
          <th v-else>
            {{
              cotacao.cot_usuario_recebedor_dados.dadosLojista.nome_responsavel
            }}
          </th>
          <th v-if="cotacao.cot_usuario_enviador_dados.dadosCliente !== null">
            {{ cotacao.cot_usuario_enviador_dados.dadosCliente.nome }}
          </th>
          <th
            v-else-if="
              cotacao.cot_usuario_recebedor_dados.dadosCliente !== null
            "
          >
            {{ cotacao.cot_usuario_recebedor_dados.dadosCliente.nome }}
          </th>
          <th
            v-if="cotacao.cot_usuario_enviador_dados.dadosProfissional !== null"
          >
            {{ cotacao.cot_usuario_enviador_dados.dadosProfissional.nome }}
          </th>
          <th
            v-else-if="
              cotacao.cot_usuario_recebedor_dados.dadosProfissional !== null
            "
          >
            {{ cotacao.cot_usuario_recebedor_dados.dadosProfissional.nome }}
          </th>
          <th>{{ cotacao.cot_preferencia }}</th>
          <th>{{ cotacao.criado_em }}</th>
          <th>{{ cotacao.cot_frete }}</th>
          <th>{{ cotacao.cot_valor_total }}</th>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="11">
            Valor total de Frete:
            <input
              type="text"
              class="form-control input-valores-totais"
              v-money="money"
              :value="cSGValorFrete"
              readonly
            />
          </th>
        </tr>
        <tr>
          <th colspan="11">
            Valor total de venda(já considera o frete):
            <input
              type="text"
              class="form-control input-valores-totais"
              v-money="money"
              :value="cSGValorTotal"
              readonly
            />
          </th>
        </tr>
      </tfoot>
    </table>

    <h3 class="title text-uppercase font-weight-bold m-t-50">
      Cotações Finalizadas
    </h3>
    <hr class="linha-amarela" />
    <table class="table">
      <thead class="letter-orange">
        <tr>
          <th>Listagem</th>
          <th>Código</th>
          <th>Representante</th>
          <th>Lojista</th>
          <th>Preferência</th>
          <th>Criado em.</th>
          <th>Frete</th>
          <th>Valor Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(cotacao, index) in cotacoesSingleFinalizadas">
          <th>{{ index + 1 }}</th>
          <th>{{ cotacao.cot_cotacao_id }}</th>
          <th v-if="cotacao.cot_usuario_enviador_dados.dadosLojista !== null">
            {{
              cotacao.cot_usuario_enviador_dados.dadosLojista.nome_responsavel
            }}
          </th>
          <th v-else>
            {{
              cotacao.cot_usuario_recebedor_dados.dadosLojista.nome_responsavel
            }}
          </th>
          <th v-if="cotacao.cot_usuario_enviador_dados.dadosCliente !== null">
            {{ cotacao.cot_usuario_enviador_dados.dadosCliente.nome }}
          </th>
          <th
            v-else-if="
              cotacao.cot_usuario_recebedor_dados.dadosCliente !== null
            "
          >
            {{ cotacao.cot_usuario_recebedor_dados.dadosCliente.nome }}
          </th>
          <th
            v-if="cotacao.cot_usuario_enviador_dados.dadosProfissional !== null"
          >
            {{ cotacao.cot_usuario_enviador_dados.dadosProfissional.nome }}
          </th>
          <th
            v-else-if="
              cotacao.cot_usuario_recebedor_dados.dadosProfissional !== null
            "
          >
            {{ cotacao.cot_usuario_recebedor_dados.dadosProfissional.nome }}
          </th>
          <th>{{ cotacao.cot_preferencia }}</th>
          <th>{{ cotacao.criado_em }}</th>
          <th>{{ cotacao.cot_frete }}</th>
          <th>{{ cotacao.cot_valor_total }}</th>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="11">
            Valor total de Frete:
            <input
              type="text"
              class="form-control input-valores-totais"
              v-money="money"
              :value="cSFValorFrete"
              readonly
            />
          </th>
        </tr>
        <tr>
          <th colspan="11">
            Valor total de venda(já considera o frete):
            <input
              type="text"
              class="form-control input-valores-totais"
              v-money="money"
              :value="cSFValorTotal"
              readonly
            />
          </th>
        </tr>
      </tfoot>
    </table>

    <h3 class="title text-uppercase font-weight-bold m-t-50">
      Cotações Canceladas
    </h3>
    <hr class="linha-amarela" />
    <table class="table">
      <thead class="letter-orange">
        <tr>
          <th>Listagem</th>
          <th>Código</th>
          <th>Representante</th>
          <th>Lojista</th>
          <th>Preferência</th>
          <th>Criado em.</th>
          <th>Frete</th>
          <th>Valor Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(cotacao, index) in cotacoesSingleCancelar">
          <th>{{ index + 1 }}</th>
          <th>{{ cotacao.cot_cotacao_id }}</th>
          <th v-if="cotacao.cot_usuario_enviador_dados.dadosLojista !== null">
            {{
              cotacao.cot_usuario_enviador_dados.dadosLojista.nome_responsavel
            }}
          </th>
          <th v-else>
            {{
              cotacao.cot_usuario_recebedor_dados.dadosLojista.nome_responsavel
            }}
          </th>
          <th v-if="cotacao.cot_usuario_enviador_dados.dadosCliente !== null">
            {{ cotacao.cot_usuario_enviador_dados.dadosCliente.nome }}
          </th>
          <th
            v-else-if="
              cotacao.cot_usuario_recebedor_dados.dadosCliente !== null
            "
          >
            {{ cotacao.cot_usuario_recebedor_dados.dadosCliente.nome }}
          </th>
          <th
            v-if="cotacao.cot_usuario_enviador_dados.dadosProfissional !== null"
          >
            {{ cotacao.cot_usuario_enviador_dados.dadosProfissional.nome }}
          </th>
          <th
            v-else-if="
              cotacao.cot_usuario_recebedor_dados.dadosProfissional !== null
            "
          >
            {{ cotacao.cot_usuario_recebedor_dados.dadosProfissional.nome }}
          </th>
          <th>{{ cotacao.cot_preferencia }}</th>
          <th>{{ cotacao.criado_em }}</th>
          <th>{{ cotacao.cot_frete }}</th>
          <th>{{ cotacao.cot_valor_total }}</th>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="11">
            Valor total de Frete:
            <input
              type="text"
              class="form-control input-valores-totais"
              v-money="money"
              :value="cSCValorFrete"
              readonly
            />
          </th>
        </tr>
        <tr>
          <th colspan="11">
            Valor total de venda(já considera o frete):
            <input
              type="text"
              class="form-control input-valores-totais"
              v-money="money"
              :value="cSCValorTotal"
              readonly
            />
          </th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { CoolSelect } from 'vue-cool-select';
import { setTimeout } from 'timers';

export default {
  name: 'cotacoes',
  data: () => ({
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: true,
    },
    filtro: {
      cidade: null,
      dataInicial: null,
      dataFinal: null,
    },
  }),
  props: ['id'],
  computed: {
    ...mapGetters(['getTipoNotification', 'getNotification']),
    ...mapState({
      cidades: (state) => state.cidades,
      cotacoesSingleEnviadas: (state) => state.cotacoesSingleEnviadas,
      cSEValorTotal: (state) => {
        let value = 0;
        if (state.cotacoesSingleEnviadas !== []) {
          for (const cotacao in state.cotacoesSingleEnviadas) {
            value += parseFloat(
              state.cotacoesSingleEnviadas[cotacao].cot_valor_total_sem_mascara
            );
          }
        }
        return value;
      },
      cSEValorFrete: (state) => {
        let value = 0;
        if (state.cotacoesSingleEnviadas !== []) {
          for (const cotacao in state.cotacoesSingleEnviadas) {
            value += parseFloat(
              state.cotacoesSingleEnviadas[cotacao].cot_frete_sem_mascara
            );
          }
        }
        return value;
      },
      cotacoesSingleGanhas: (state) => state.cotacoesSingleGanhas,
      cSGValorTotal: (state) => {
        let value = 0;
        if (state.cotacoesSingleGanhas !== []) {
          for (const cotacao in state.cotacoesSingleGanhas) {
            value += parseFloat(
              state.cotacoesSingleGanhas[cotacao].cot_valor_total_sem_mascara
            );
          }
        }
        return value;
      },
      cSGValorFrete: (state) => {
        let value = 0;
        if (state.cotacoesSingleGanhas !== []) {
          for (const cotacao in state.cotacoesSingleGanhas) {
            value += parseFloat(
              state.cotacoesSingleGanhas[cotacao].cot_frete_sem_mascara
            );
          }
        }
        return value;
      },
      cotacoesSingleFinalizadas: (state) => state.cotacoesSingleFinalizadas,
      cSFValorTotal: (state) => {
        let value = 0;
        if (state.cotacoesSingleFinalizadas !== []) {
          for (const cotacao in state.cotacoesSingleFinalizadas) {
            value += parseFloat(
              state.cotacoesSingleFinalizadas[cotacao]
                .cot_valor_total_sem_mascara
            );
          }
        }
        return value;
      },
      cSFValorFrete: (state) => {
        let value = 0;
        if (state.cotacoesSingleFinalizadas !== []) {
          for (const cotacao in state.cotacoesSingleFinalizadas) {
            value += parseFloat(
              state.cotacoesSingleFinalizadas[cotacao].cot_frete_sem_mascara
            );
          }
        }
        return value;
      },
      cotacoesSingleCancelar: (state) => state.cotacoesSingleCancelar,
      cSCValorTotal: (state) => {
        let value = 0;
        if (state.cotacoesSingleCancelar !== []) {
          for (const cotacao in state.cotacoesSingleCancelar) {
            value += parseFloat(
              state.cotacoesSingleCancelar[cotacao].cot_valor_total_sem_mascara
            );
          }
        }
        return value;
      },
      cSCValorFrete: (state) => {
        let value = 0;
        if (state.cotacoesSingleCancelar !== []) {
          for (const cotacao in state.cotacoesSingleCancelar) {
            value += parseFloat(
              state.cotacoesSingleCancelar[cotacao].cot_frete_sem_mascara
            );
          }
        }
        return value;
      },
    }),
  },
  components: {
    CoolSelect,
  },
  created() {
    const d = new Date();
    const month = d.getMonth() + 1;
    const ld = new Date(2019, month, 0);

    const value = {
      id: this.id,
      cidade: this.filtro.cidade,
      dataInicial: {
        dia: String(d.getDate()).padStart(2, '0'),
        mes: String(d.getMonth() + 1).padStart(2, '0'),
        ano: d.getFullYear(),
      },
      dataFinal: {
        dia: String(ld.getDate()).padStart(2, '0'),
        mes: String(d.getMonth() + 1).padStart(2, '0'),
        ano: d.getFullYear(),
      },
    };

    this.$store.dispatch('startLoader');
    this.$store.dispatch('loadCidades');
    this.$store
      .dispatch('showCotacoesUsuarioEnviadasVendasWithTime', value)
      .then(() => {
        setTimeout(() => {
          this.$store.dispatch('endLoader');
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          this.$store.dispatch('endLoader');
        }, 1000);
      });
    this.$store
      .dispatch('showCotacoesUsuarioGanhasVendasWithTime', value)
      .then(() => {
        setTimeout(() => {
          this.$store.dispatch('endLoader');
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          this.$store.dispatch('endLoader');
        }, 1000);
      });
    this.$store
      .dispatch('showCotacoesUsuarioCanceladasVendasWithTime', value)
      .then(() => {
        setTimeout(() => {
          this.$store.dispatch('endLoader');
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          this.$store.dispatch('endLoader');
        }, 1000);
      });
    this.$store
      .dispatch('showCotacoesUsuarioFinalizadasVendasWithTime', value)
      .then(() => {
        setTimeout(() => {
          this.$store.dispatch('endLoader');
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          this.$store.dispatch('endLoader');
        }, 1000);
      });
  },
  methods: {
    buscar() {
      let d;
      let month;
      let ld;
      let dataInicial;
      let dataFinal;
      let self;
      self = this;
      d = new Date();
      month = d.getMonth() + 1;
      ld = new Date(2019, month, 0);

      dataInicial = {
        dia: String(d.getDate()).padStart(2, '0'),
        mes: String(d.getMonth() + 1).padStart(2, '0'),
        ano: d.getFullYear(),
      };

      dataFinal = {
        dia: String(ld.getDate()).padStart(2, '0'),
        mes: String(d.getMonth() + 1).padStart(2, '0'),
        ano: d.getFullYear(),
      };

      if (this.filtro.dataInicial !== null) {
        const filtroInicial = this.filtro.dataInicial.split('-');
        dataInicial = {
          dia: filtroInicial[2],
          mes: filtroInicial[1],
          ano: filtroInicial[0],
        };
      }

      if (this.filtro.dataFinal !== null) {
        const filtroFinal = this.filtro.dataFinal.split('-');
        dataFinal = {
          dia: filtroFinal[2],
          mes: filtroFinal[1],
          ano: filtroFinal[0],
        };
      }

      const value = {
        id: this.id,
        cidade: this.filtro.cidade,
        dataInicial,
        dataFinal,
      };

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('showCotacoesUsuarioEnviadasVendasWithTime', value)
        .then(() => {
          setTimeout(() => {
            this.$store.dispatch('endLoader');
          }, 1000);
        })
        .catch(() => {
          setTimeout(() => {
            this.$store.dispatch('endLoader');
          }, 1000);
        });
      this.$store
        .dispatch('showCotacoesUsuarioGanhasVendasWithTime', value)
        .then(() => {
          setTimeout(() => {
            this.$store.dispatch('endLoader');
          }, 1000);
        })
        .catch(() => {
          setTimeout(() => {
            this.$store.dispatch('endLoader');
          }, 1000);
        });
      this.$store
        .dispatch('showCotacoesUsuarioCanceladasVendasWithTime', value)
        .then(() => {
          setTimeout(() => {
            this.$store.dispatch('endLoader');
          }, 1000);
        })
        .catch(() => {
          setTimeout(() => {
            this.$store.dispatch('endLoader');
          }, 1000);
        });
      this.$store
        .dispatch('showCotacoesUsuarioFinalizadasVendasWithTime', value)
        .then(() => {
          setTimeout(() => {
            this.$store.dispatch('endLoader');
          }, 1000);
        })
        .catch(() => {
          setTimeout(() => {
            this.$store.dispatch('endLoader');
          }, 1000);
        });
    },
  },
};
</script>
